/* eslint-disable */
import { readsPerMinute,concentratorArea,specificHeatOfWater,gallonsInTank,litersPerGallon,mCubedInTank } from 'src/utils/constants';

export function getIncidentEnergy(dniReading){
  return dniReading * concentratorArea;
}

export function getWattsAsKilowattsPer15Seconds(valueInWatts){
  //value in watts would be kilowatt/hours if it lasted for 1 hour at this value. 
  //we read every 15 seconds so our watt reading is 1/4 of 1/60 of a kilowatt/hour
  return ((valueInWatts/60)/readsPerMinute)/1000;
}

export function calculateEnthalpy(inlet, outlet, litersPerMin){
  if(inlet == null | outlet == null){
    console.log("missing param")
    return 0;
  }else{

    var specificHeat = getSpecificHeat(Number(inlet))
    //console.log("specific heat  "+specificHeat)
    var flowRate = getflowInKgPerSec(Number(litersPerMin), Number(inlet) )
    //console.log("flowRate"+ flowRate)
    var deltaT  = outlet - inlet;
    //console.log("delta t:"+ deltaT)
    var solarPower =  getSolarPowerInKw(specificHeat, flowRate, deltaT)*1000; //kW to W
    //console.log(solarPower)
    return solarPower
  }
}

// 25% Glycol
function getSpecificHeat(temp){
  var specificHeat = (0.0025*temp) + 3.8628
  return specificHeat;
}

function getSpecificHeat28(temperature){
  //Assumes 28% glycol
  var specificHeat = ((0.0006*Number(temperature)) + 0.913)*4.186;
  return specificHeat
}

function getSpecificHeat50(temperature){
  var specificHeat = (Number(temperature)+894.61)/258.84;
  return specificHeat;
}


// 25% Glycol
function getDensity(temp){
  // X = (Y-1731.8)/-1.6733
  var density = (temp - 1731.8)/-1.6733
  return density;
}

// 28% Glycol
function getDensity28(temp){
  //Assumes 28% glycol    y = -0.0025x2 - 0.3346x + 1034.2 where x=temperature in degrees C and y= Kg
  var firstParam =  -0.0025 * Number(temp)
  var firstSqrd = Math.pow(firstParam,2);
  
  var secondParam = 0.3346 * Number(temp)

  var thirdParam = 1034.2

  var density = firstSqrd - secondParam + thirdParam;

  return density;
}


//Flow Rate  Kg / Sec —> Liters/minute x (1/60 minutes/sec) x (1/1000 m^3/Liter) x Kg / m^3 = Kg / Sec
function getflowInKgPerSec(litersPerMin, temp){
  var litersPerSec = litersPerMin/60;
  var density = getDensity(temp);
  var kgPerSec = litersPerSec * density /1000;
  return kgPerSec;
}

//Solar power  —> kW thermal = kJ / Sec = (Sp. Heat kJ/kg-C) x (Kg / Sec) x (Delta T deg C)
function getSolarPowerInKw(specificHeat, flowRate, deltaT){
  if (deltaT === 0){
    return 0;
  }else{

  return specificHeat * flowRate * deltaT;
  }
}

//Q = Mass x Specific heat x Delta T
export function getThermalEnergyStored(tankTemp, greenhouseOut){ 
  var specificHeat= getSpecificHeat(tankTemp);  

  var deltaT = tankTemp - greenhouseOut;

  var mass =  getDensity(tankTemp) * mCubedInTank;

  var retval =  getKjAsKWh(Number(mass) * Number(specificHeat) * Number(deltaT));

  if(retval< 0){
    //console.log("No stored Energy available. Tank is colder than greenhouse. ");
    let logVal = Number(retval*-1).toFixed(2)
    //console.log("Tank needs "+logVal+"kWh for temp parity");
    retval = 0;
  }

  return retval;
} 

function getKjAsKWh(kJ){
  return kJ/3600;
}